export function isSandbox(): boolean {
	const url = window.location.href;
	return url.indexOf("lacto") > 0 || url.indexOf("localhost") > 0 || url.indexOf("192.168") > 0;
}

export function isLocalHost(): boolean {
	return window.location.href.includes("localhost");
}
